import dayjs from "dayjs";
import { APP_SERVER_API, CORE_API, DASHBOARD_API } from "../constants";
import { getData, postData } from "./common.service";

class SensorDataService {
  private static readonly baseUrl = "/sensor-data";
  private static readonly diseasePestBaseUrl = "/plot<disease/pest>Predictions/get<timeFrame>Data";
  private static readonly diseasePestCustomDateBaseUrl = "/plot<disease/pest>Predictions/getDataBetweenDates";

  static getSensorData = (
    args: TGetSensorDataReqArgs,
  ): Promise<TSensorDataResponse> => {
    const { plotId, startDate, endDate, dataType, field } = args;
    const sampleSize = args.sampleSize;

    let filterUrl = `?plotId=${plotId}&field=${field}&startTime=${startDate}&endTime=${endDate}&dataType=${dataType}`;

    if(sampleSize) {
      filterUrl += `&sampleSize=${sampleSize}`;
    }


    const url = this.baseUrl + filterUrl;
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static getDiseasePestData = (args: TGetDiseasePestDataReqArgs) => {
    const { plotId, startDate, endDate, diseaseId, dataFor } = args;

    const url = this.generateDiseasePestUrl(dataFor, "custom");

    /**
     * whether to pass diseaseId or pestId based on dataFor
     */
    const diseasePestId = dataFor === "Disease" ? "diseaseId" : "pestId";

    const body = {
      fromDate: dayjs(startDate).toString(),
      toDate: dayjs(endDate).toString(),
      plotId,
      [diseasePestId]: diseaseId,
    };
    return postData(url, {
      basePath: APP_SERVER_API,
      sendTokenInUrl: true,
      body
    });
  };

  static getDiseasePestImages = () => {
    const url = DASHBOARD_API;
    console.log("url", url);
  };

  static generateDiseasePestUrl = (urlFor: "Disease" | "Pest" = "Disease", timeFrame: string) => {
    if(timeFrame === "custom") {
      return this.diseasePestCustomDateBaseUrl
        .replace("<disease/pest>", urlFor);
    }

    return this.diseasePestBaseUrl
      .replace("<disease/pest>", urlFor)
      .replace("<timeFrame>", timeFrame);
  };
}

export default SensorDataService;

type TGetSensorDataReqArgs = {
  plotId: string;
  startDate: string;
  endDate: string;
  dataType: "daily" | "hourly";
  sampleSize?: number;
  field: string;
};

type TGetDiseasePestDataReqArgs = {
  plotId: string;
  diseaseId: string;
  startDate: string;
  endDate: string;
  dataFor: "Disease" | "Pest";
}

export type TSensorDataResponse = {
  min: TMinMaxValues;
  max: TMinMaxValues;
  avg: number;
  sum: number;
  data: Array<TDataItem>;
  sample: Array<SampleItem>;
};

export type TMinMaxValues = {
  min: number;
  max: number;
  timestamp: string;
  [field: string]: number | string;
};

export type TDataItem = {
  [field: string]: number | string;
  min: number;
  max: number;
  timestamp: string;
  stageChanged: number;
  stageName: string;
  maxOptimalValue: number;
  minOptimalValue: number;
  displayName: string;
  vpd:number;
  soilMoisture1:number;
  minThresholdValue:number;
  maxThresholdValue:number;
  soilMoisture2:number;

};

// export type SampleItem = {
//   x: string;
//   y: number;
//   min: number;
//   max: number;
//   timestamp: string;
//   stageChanged: number;
//   stageName: string;
//   maxOptimalValue: number;
//   minOptimalValue: number;
//   maxThresholdValue:number;
//   minThresholdValue:number;
//   soilMoisture1:number;
//   soilMoisture2:number;
//   displayName: string;
//   [field: string]: string | number;
// };
export type SampleItem = {
  x?: string;                       // Make x optional
  y?: number;                       // Make y optional
  min: number;
  max: number;
  timestamp: string;
  stageChanged?: number;            // Make stageChanged optional
  stageName?: string;               // Make stageName optional
  maxOptimalValue?: number;         // Make maxOptimalValue optional
  minOptimalValue?: number;         // Make minOptimalValue optional
  maxThresholdValue?: number;       // Make maxThresholdValue optional
  minThresholdValue?: number;       // Make minThresholdValue optional
  soilMoisture1?: number;          // Make soilMoisture1 optional
  soilMoisture2?: number;          // Make soilMoisture2 optional
  displayName?: string;             // Make displayName optional
  color?: string;
  vpd?:number;
  [field: string]: string | number | undefined; // Allow other fields with string or number values
};
